/* eslint-disable no-param-reassign */
import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useStore } from 'react-redux'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { updateUserInvoce } from '../../../store/actions/invoices'
import { clearJson } from '../../../store/actions/setJson'
import styles from './Modal.module.scss'

/**
* @author
* @function SavingModal
* */

const SavingModal = props => {
	const { requestClose } = props
	const dispatch = useDispatch()
	const store = useStore()
	function handleModify() {
		const { modifiedValues } = store.getState().modifyInvoice
		const initialValues = store.getState().jsonVal.jsonVal
		const mutateObjectProperty = (prop, value, obj) => (
			obj.constructor === Object && Object.keys(obj).forEach(key => {
				if (key === prop) obj[key].value = value
				mutateObjectProperty(prop, value, obj[key])
			}))

		Object.keys(modifiedValues).map(currKey => {
			mutateObjectProperty(currKey, modifiedValues[currKey], initialValues)
			return true
		})
		const newInvoiceData = initialValues
		Promise.all([
			dispatch(updateUserInvoce({}, { invoiceId: 'da650171-cd1b-4da8-820e-f044d8c99a61', json: newInvoiceData })),
		]).then(() => {
			toast.success('Modification successful', {
				position: toast.POSITION.BOTTOM_RIGHT,
			})
			dispatch(clearJson())
			requestClose()
		})
	}
	return (
		<div className={styles.savingModal}>
			<div className={styles.header}>
				<h1>
					You are about to modify an invoice!
				</h1>
			</div>
			<div className={styles.buttonContainer}>
				<button
					className={styles.button}
					type="button"
					onClick={() => handleModify()}
				>
					modify
				</button>
				<button
					className={styles.negative}
					type="button"
					onClick={requestClose}
				>
					discard
				</button>
			</div>
		</div>
	)
}

SavingModal.defaultProps = {
	// modalData: null,
	requestClose: null,
}

SavingModal.propTypes = {
	// modalData: PropTypes.objectOf({}),
	requestClose: PropTypes.func,
}

export default SavingModal
